
import PaymentSection from './section.vue'
import { Prop, Component } from 'vue-property-decorator'
import Vue from 'vue'
import { Job, JobFinancials, SectionData } from '@/domains/global/models'
import axios from 'axios'

@Component({
  components: { PaymentSection }
})
export default class FinancialCard extends Vue {
  @Prop({ type: Object, required: true })
  private readonly job!: Job

  financials: JobFinancials | null = null
  breakdown: SectionData[] = []

  async mounted() {
    try {
      const response = await axios.get<JobFinancials>(`jobs/${this.job.id}/financials`)
      this.financials = response.data
      this.updateBreakdown(this.financials)
    } catch (error: any) {
      if (!error.response || error.response.status !== 404) {
        throw error
      }
    }
  }
  updateBreakdown(jobFinancials: JobFinancials) {
    if (!jobFinancials) {
      return
    }
    this.breakdown = [
      {
        item: { label: 'Provider Total Inc Tax', amount: jobFinancials.providerTotalIncTax },
        children: [
          { label: 'Provider Total Ex Tax', amount: jobFinancials.providerTotalExTax },
          { label: 'Provider Total Tax', amount: jobFinancials.providerTax }
        ]
      }, {
        item: { label: 'Agency Total Inc Tax', amount: jobFinancials.agencyTotalIncTax },
        children: [
          { label: 'Agency Total Ex Tax', amount: jobFinancials.agencyTotalExTax },
          { label: 'Agency Total Tax', amount: jobFinancials.agencyTax }
        ]
      }, {
        item: { label: 'Service Total Inc Tax', amount: jobFinancials.serviceTotalIncTax },
        children: [
          { label: 'Service Total Ex Tax', amount: jobFinancials.serviceTotalExTax },
          { label: 'Service Total Tax', amount: jobFinancials.serviceTax }
        ]
      }, {
        item: { label: 'Provider Postage Total Inc Tax', description: 'Already included in provider totals', amount: jobFinancials.providerPostageTotalIncTax },
        children: [
          { label: 'Postage Total Ex Tax', amount: jobFinancials.providerPostageTotalExTax },
          { label: 'Postage Total Tax', amount: jobFinancials.providerPostageTotalTax }
        ]
      }, {
        item: { label: 'Agency Postage Total Inc Tax', description: 'Already included in agency totals', amount: jobFinancials.agencyPostageTotalIncTax },
        children: [
          { label: 'Postage Total Ex Tax', amount: jobFinancials.agencyPostageTotalExTax },
          { label: 'Postage Total Tax', amount: jobFinancials.agencyPostageTotalTax }
        ]
      }, {
        item: { label: 'Job Total Inc Tax', amount: jobFinancials.jobTotalIncTax },
        children: [
          { label: 'Job Total Ex Tax', amount: jobFinancials.jobTotalExTax },
          { label: 'Job Total Tax', amount: jobFinancials.jobTotalTax }
        ]
      }
    ]
  }
}
